<template>
    <section class="min-h-screen bg-white px-6 py-40">
        <div class="max-w-5xl mx-auto">
            <h1 class="text-4xl font-extrabold text-gray-900 mb-16 text-center tracking-tight">
                Plan du site
            </h1>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-16">
                <!-- Navigation principale -->
                <nav>
                    <h2 class="text-2xl font-semibold text-black mb-6 border-b-2 border-black pb-2">
                        Navigation principale
                    </h2>
                    <ul class="space-y-3 text-black text-lg">
                        <li>
                            <RouterLink to="/" class="hover:text-primary">Accueil</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/pricing" class="hover:text-primary">Tarifs</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/register" class="hover:text-primary">Créer ma vitrine</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/login" class="hover:text-primary">Connexion</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/contact" class="hover:text-primary">Contact</RouterLink>
                        </li>
                    </ul>
                </nav>

                <!-- Informations légales -->
                <section>
                    <h2 class="text-2xl font-semibold text-black mb-6 border-b-2 border-black pb-2">
                        Informations légales
                    </h2>
                    <ul class="space-y-3 text-black text-lg">
                        <li>
                            <RouterLink to="/legal" class="hover:text-primary">Mentions légales</RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/privacy-policy" class="hover:text-primary">Politique de confidentialité
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/plan-site" class="hover:text-primary">Plan du site</RouterLink>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </section>
</template>

<script setup>
// Aucun JS nécessaire
</script>
